"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeAsyncCard = require("crm_ui/sidebar/makeAsyncCard");

var propTypes = {
  isUngatedForGraphQL: _propTypes.default.bool
};

function ProfileWebsiteActivityTitleWrapper(props) {
  var WebsiteActivityTitle = props.isUngatedForGraphQL ? (0, _makeAsyncCard.makeAsyncCard)({
    chunkName: 'sidebar-website-activity-title-graphql',
    loader: function loader() {
      return import(
      /* webpackChunkName: "sidebar-website-activity-title-graphql" */
      'crm_ui/profile/sidebar/contacts/ProfileWebsiteActivityTitle');
    }
  }) : (0, _makeAsyncCard.makeAsyncCard)({
    chunkName: 'sidebar-website-activity-title-legacy',
    loader: function loader() {
      return import(
      /* webpackChunkName: "sidebar-website-activity-title-legacy" */
      'crm_ui/profile/sidebar/contacts/ProfileWebsiteActivityTitleContainer');
    }
  });
  return _react.default.createElement(WebsiteActivityTitle, props);
}

ProfileWebsiteActivityTitleWrapper.propTypes = propTypes;
var _default = ProfileWebsiteActivityTitleWrapper;
exports.default = _default;
module.exports = exports.default;